import { injected } from 'wagmi/connectors';

// Using a placeholder icon URL for now
const backpackIcon = 'https://backpack.app/favicon.ico';

export const backpackConnector = () => {
    const c = injected({
        target: () => (typeof window !== 'undefined' ? (window as any).backpack : undefined), // Often injects as 'backpack' or overrides ethereum? 
        // Backpack usually injects window.backpack or window.xnft
        // For EVM, it might just be window.ethereum with isBackpack? 
        // We will try window.backpack first, if not, fallback to custom detection logic if needed.
        // @ts-ignore
        shimDisconnect: true,
    });

    return (ctx: any) => {
        const connector = c(ctx);
        
return {
            ...connector,
            getProvider: () => connector.getProvider(),
            id: 'backpack',
            name: 'Backpack',
            icon: backpackIcon,
            getWalletConnectDeeplink: null,
            getQrCode: () => null,
            // @ts-ignore
            isAuthorized: async () => {
                if (typeof window !== 'undefined' && !(window as any).backpack) {
                    return false;
                }
                
return connector.isAuthorized();
            },
            get installed() {
                return typeof window !== 'undefined' && !!(window as any).backpack;
            },
            get suggested() {
                return false;
            },
            extension: {
                instructions: {
                    learnMoreUrl: 'https://backpack.app/',
                    steps: [],
                },
            },
            downloadUrls: {
                get download() {
                    if (typeof window === 'undefined')
                         return 'https://backpack.app/downloads';

                    const isMobile = /iPhone|iPad|iPod|Android/i.test(
                        window.navigator.userAgent,
                    );

                    if (isMobile) {
                        const dappUrl = window.location.href;
                        const ref = window.location.origin;

                        return `https://backpack.app/ul/browse/${encodeURIComponent(dappUrl)}?ref=${encodeURIComponent(ref)}`;
                    }

                    return 'https://backpack.app/downloads';
                },
            },
        };
    };
};
